import { Button, Col, Collapse, Divider, Row, Skeleton, Steps, Upload } from 'antd';
import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import API from 'API';
import QuizList from './QuizList';
import toastr from 'toastr';
import ReactMarkdown from "react-markdown";
import { correct_media } from 'general_function';
import { NotFound } from 'AppRoute';
import ScormPlayer from 'components/general/ScormPlayer';

const videoProcess = [
    {
        title: 'Đang chờ',
    },
    {
        title: 'Phân tách frame',
    },
    {
        title: 'Cắt âm thanh',
    },
    {
        title: 'Xử lý âm thanh',
    },
    {
        title: 'Phân tích nội dung',
    },
    {
        title: 'Tối ưu nội dung',
    },
    {
        title: 'Kết hợp nội dung',
    },
    {
        title: 'Hoàn thành',
    },
]

function correct_time_format(time) {
    var min = Math.floor(time / 60)
    var sec = Math.floor(time % 60)
    if (min < 10) min = "0" + min
    if (sec < 10) sec = "0" + sec
    return `${min}:${sec}`
}

function DataMapping({ data }) {
    if (!data) return ""
    return <ul style={{ textAlign: "left" }}>
        {data.map(item => <li>
            <b>{correct_time_format(item.start_time)} - {correct_time_format(item.end_time)}:</b> {item.title}
        </li>)}
    </ul>
}

export default function UniversityLesson() {
    const { id } = useParams();
    const [lesson, setLesson] = useState(null)
    const [loading, setLoading] = useState(true)
    const [file, setFile] = useState(null)
    const [pdfFile, setPdfFile] = useState(null)
    const [scormFile, setScormFile] = useState(null)
    const [genning, setGenning] = useState(false);
    const [sendingPDF, setSendingPDF] = useState(false);
    const [sendingScorm, setSendingScorm] = useState(false);
    const [genningContent, setGenningContent] = useState(false);
    const [uploadingVideo, setUploadingVideo] = useState(false);

    useEffect(() => {
        if (!lesson) return;
        document.title = lesson.name;
    },[lesson])

    useEffect(() => {
        API.get(`lessons/${id}/`)
            .then(res => {
                setLesson(res.data);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            })
    }, [id])
    useEffect(() => {
        if (!lesson || !lesson.video || lesson.video.process === 7) {
            return
        }
        setTimeout(() => {
            API.get(`videos/${lesson.video.id}/`)
                .then(res => {
                    setLesson(lesson => ({
                        ...lesson, video: res.data
                    }))
                    setLoading(false)
                })
                .catch(error => {
                    console.log(error)
                })
        }, 5000)
        // eslint-disable-next-line
    }, [lesson && lesson.video])
    const submitVideo = () => {
        if (!file) return;
        const formData = new FormData();
        formData.append("file", file)
        formData.append("lesson_id", id)
        setLesson(lesson => ({
            ...lesson, video: null
        }))
        setUploadingVideo(true);
        API.post("lesson-video/", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(res => {
                setLesson(lesson => ({
                    ...lesson, video: res.data
                }))
                setFile(null);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(()=>{
                setUploadingVideo(false);
            })
    }
    const submitPdf = () => {
        if (!pdfFile) return;
        const formData = new FormData();
        formData.append("file", pdfFile);
        formData.append("lesson_id", id);
        setSendingPDF(true);
        API.post("lesson-file/", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(res => {
                setLesson(lesson => ({
                    ...lesson, pdf_files: [...lesson.pdf_files, res.data]
                }))
            })
            .catch(error => {
                if (error?.response?.data?.error) {
                    toastr.error(error?.response?.data?.error);
                    return;
                }
            })
            .finally(()=>{
                setSendingPDF(false);
                setPdfFile(null);
            })
    }

    const submitScorm = useCallback(() => {
        if (!scormFile) return;
        const formData = new FormData();
        formData.append("file", scormFile);
        formData.append("lesson_id", id);
        setSendingScorm(true);
        API.post("lesson-scorm/", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(res => {
                setLesson(lesson => ({
                    ...lesson, scorms: [res.data]
                }))
            })
            .catch(error => {
                if (error?.response?.data?.error) {
                    toastr.error(error?.response?.data?.error);
                    return;
                }
            })
            .finally(()=>{
                setSendingScorm(false);
                setScormFile(null);
            })
    },[scormFile, id])

    const gen_content = () => {
        setGenningContent(true)
        API.post("lesson-content/", { lesson_id: id })
            .then(res => {
                setLesson(lesson => ({
                    ...lesson, content: res.data.result
                }))
            })
            .catch(error => {
                if (error?.response?.data?.error) {
                    toastr.error(error?.response?.data?.error);
                    return;
                }
            })
            .finally(() => {
                setGenningContent(false);
            })
    }
    const gen_exercise = () => {
        setGenning(true)
        API.post("generate-exercise/", { lesson_id: id })
            .then(res => {
                toastr.success("Tạo câu hỏi thành công, vui lòng chờ trông giây lát rồi tải lại trang.")
            })
            .catch(error => {
                if (error?.response?.data?.error) {
                    toastr.error(error?.response?.data?.error)
                    return;
                }
                console.log(error)
            })
            .finally(() => {
                setGenning(false)
            })
    }
    return loading ? <Skeleton active /> : !lesson ? <NotFound />
    : <>
        <Divider>
            {lesson.name}
        </Divider>
        {/* <div style={{ position: "relative" }}>
            <Collapse items={[{
                key: 1,
                label: "Nội dung bài học",
                children: <div style={{ textAlign: "left"}}><ReactMarkdown>{lesson.content}</ReactMarkdown></div>
            }]} />
            <Button type='primary' onClick={gen_content} loading={genningContent} style={{ position: "absolute", top: 8, right: 16 }}>
                Khởi tạo nội dung
            </Button>
        </div> */}
        <Row gutter={8}>
            <Col span={24} lg={20}>
                <Divider orientation="center">Scorm</Divider>
                {lesson.scorms.length === 0 ? <div>Không có bài giảng scorm</div> 
                : <ScormPlayer scorm={lesson.scorms[0]}/>}
                <Divider orientation="center">Video</Divider>
                <div>{lesson.video ? <>
                    <div style={{ textAlign: "center" }}>
                        <video width="640" controls style={{maxWidth: "100%"}}>
                            <source src={correct_media(lesson.video.file)} type="video/mp4" />
                        </video>
                    </div>
                    <Collapse items={[{
                        key: 1,
                        label: "Nội dung video theo mốc thời gian",
                        children: <DataMapping data={lesson.video.data} />
                    }]} />
                    <Collapse items={[{
                        key: 1,
                        label: "Nội dung video tổng kết",
                        children: <div style={{ textAlign: "left"}}><ReactMarkdown>{lesson.video.content}</ReactMarkdown></div>
                    }]} />
                    <Steps
                        style={{ marginTop: 10 }}
                        current={lesson.video.process}
                        items={videoProcess}
                    />
                    {lesson.video.error && <div style={{ textAlign: "left", color: "red" }}>
                        Xử lý video lỗi: <pre>{lesson.video.error.replace("[rehandle]","")}</pre>
                        {lesson.video.error.startsWith("[rehandle]") && <Button type="primary" onClick={() => {
                            API.post("rehandle-video/", { video_id: lesson.video.id })
                                .then(res => {
                                    setLesson(lesson => ({
                                        ...lesson, video: {
                                            ...lesson.video,
                                            error: null
                                        }
                                    }))
                                })
                                .catch(error => { console.log(error) })
                        }}>Xử lý lại</Button>}
                    </div>}
                </> : "Chưa có video"}</div>
                <div style={{ textAlign: "center", marginTop: 10 }}>
                    <Upload name="file" customRequest={(a) => {
                        setFile(a.file);
                        a.onSuccess();
                    }} maxCount={1} accept="video/mp4">
                        <Button icon={<UploadOutlined />}>Chọn video</Button>
                    </Upload>
                    <Button type="primary" onClick={submitVideo} style={{marginTop: 3}} disabled={!file} loading={uploadingVideo}>
                        Up video
                    </Button>
                </div>
            </Col>
            <Col span={24} lg={4} style={{
                wordWrap: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "normal"
            }}>
                <Divider orientation="center">Files</Divider>
                <Upload name="file" customRequest={(a) => {
                    setPdfFile(a.file);
                    a.onSuccess();
                }} maxCount={1} accept=".pdf" fileList={pdfFile ? [pdfFile] : []}>
                    <Button icon={<UploadOutlined />} loading={sendingPDF}>Chọn file</Button>
                </Upload>
                <Button type="primary" loading={sendingPDF} onClick={submitPdf}>
                    Up file
                </Button>
                <ul>
                    {lesson.pdf_files.map((item) => <li key={item.id}>
                        <a href={correct_media(item.file)} target='_blank' rel="noreferrer">{item.file.split('/').pop()}</a> - <DeleteOutlined onClick={() => {
                            API.delete(`pdf-files/${item.id}/`)
                                .then(() => {
                                    setLesson(lesson => ({
                                        ...lesson, pdf_files: lesson.pdf_files.filter(a => a.id !== item.id)
                                    }))
                                })
                                .catch((error) => { console.log(error) })
                        }} style={{ color: "red", cursor: "pointer" }} />
                    </li>)}
                </ul>
                <Divider orientation="center">Scorm</Divider>
                <Upload name="file" customRequest={(a) => {
                    setScormFile(a.file);
                    a.onSuccess();
                }} maxCount={1} accept=".zip" fileList={scormFile ? [scormFile] : []}>
                    <Button icon={<UploadOutlined />} loading={sendingScorm}>Chọn file</Button>
                </Upload>
                <Button type="primary" loading={sendingScorm} onClick={submitScorm}>
                    Up file
                </Button>
            </Col>
        </Row>
        <Divider>Bài tập</Divider>
        <div style={{ textAlign: "center", marginTop: 10 }}>
            <Button type="primary" onClick={gen_exercise} loading={genning}>
                Tạo bài tập
            </Button>
        </div>
        <QuizList quizzes={lesson.quizzes} essays={lesson.essays}/>
    </>
}
